module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cball"
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "min-height": "570px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "contact flex align-center",
    attrs: {
      "span": 24
    }
  }, [_c('el-image', {
    staticClass: "c_img",
    attrs: {
      "src": "/static/assets/images/icon1.png",
      "fit": "fill"
    }
  }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(_vm.config.people) + _vm._s(_vm.config.phone))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "contact flex align-center",
    attrs: {
      "span": 24
    }
  }, [_c('el-image', {
    staticClass: "c_img",
    attrs: {
      "src": "/static/assets/images/icon2.png",
      "fit": "fill"
    }
  }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(_vm.config.email))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "contact flex align-center",
    attrs: {
      "span": 24
    }
  }, [_c('el-image', {
    staticClass: "c_img",
    attrs: {
      "src": "/static/assets/images/icon3.png",
      "fit": "fill"
    }
  }), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(_vm.config.address))])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rtitle flex justify-between align-center bg-white rone"
  }, [_c('div', {
    staticClass: "colorleft"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "colorright"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7712427b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mine/concat_us.vue
// module id = 407
// module chunks = 1